const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');
const formatMessage = require('format-message');

// eslint-disable-next-line max-len
const menuIconURI = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSI0IiBmaWxsPSIjRkY4QzFBIi8+PHBhdGggZD0iTTUgNi41QzUgNS42NzE1NyA1LjY3MTU3IDUgNi41IDVIMTMuNUMxNC4zMjg0IDUgMTUgNS42NzE1NyAxNSA2LjVWOS41QzE1IDEwLjMyODQgMTQuMzI4NCAxMSAxMy41IDExSDYuNUM1LjY3MTU3IDExIDUgMTAuMzI4NCA1IDkuNVY2LjVaIiBmaWxsPSJ3aGl0ZSIvPjxjaXJjbGUgY3g9IjEwIiBjeT0iOCIgcj0iMi4zIiBmaWxsPSIjRkY4QzFBIi8+PHBhdGggZD0iTTQuNSAxNC41QzUuNjA4ODMgMTMuMDQwMyA3LjM4NjgxIDEyIDkuNCAxMkMxMS40MTMyIDEyIDEzLjE5MTEgMTMuMDQwMyAxNC4zIDE0LjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L3N2Zz4=';
// eslint-disable-next-line max-len
const blockIconURI = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIzIiB5PSIzIiB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHJ4PSI4IiBmaWxsPSIjRkY4QzFBIi8+PHJlY3QgeD0iMTAiIHk9IjEyIiB3aWR0aD0iMjAiIGhlaWdodD0iMTAiIHJ4PSI0IiBmaWxsPSJ3aGl0ZSIvPjxjaXJjbGUgY3g9IjIwIiBjeT0iMTciIHI9IjQuMyIgZmlsbD0iI0ZGOEMxQSIvPjxwYXRoIGQ9Ik0xMCAyOC41QzExLjg1NTUgMjYuMDY4NCAxNC44MzU5IDI0LjMzMzMgMTguMiAyNC4zMzMzSDIxLjhDMjUuMTY0MSAyNC4zMzMzIDI4LjE0NDUgMjYuMDY4NCAzMCAyOC41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPjwvc3ZnPg==';

const defaultState = () => ({
    currentLabel: '',
    confidences: {},
    trainingCounts: {},
    labels: [],
    isPredicting: false,
    modelReady: false,
    videoPreviewState: 'on',
    videoTransparency: 50
});

class Scratch3VisionClassifierBlocks {
    constructor (runtime) {
        this.runtime = runtime;
        this._state = defaultState();

        this.runtime.visionClassifier = {
            clearState: this.clearState.bind(this),
            getState: this.getState.bind(this),
            openTrainer: this.openTrainer.bind(this),
            requestClearTraining: this.requestClearTraining.bind(this),
            setCameraPreviewState: this.setCameraPreviewState.bind(this),
            setModelReady: this.setModelReady.bind(this),
            setPrediction: this.setPrediction.bind(this),
            setTrainingData: this.setTrainingData.bind(this),
            setPredicting: this.setPredicting.bind(this)
        };

        this.runtime.on('PROJECT_STOP_ALL', this.handleProjectStop.bind(this));
        this._applyCameraPreviewState();
    }

    getInfo () {
        return {
            id: 'visionClassifier',
            name: formatMessage({
                id: 'visionClassifier.categoryName',
                default: 'Data',
                description: 'Navn pÃ¥ dataudvidelsens kategori'
            }),
            blockIconURI: blockIconURI,
            menuIconURI: menuIconURI,
            color1: '#FF8C1A',
            color2: '#DB6E00',
            color3: '#B85A00',
            blocks: [
                {
                    opcode: 'whenVisionLabel',
                    blockType: BlockType.HAT,
                    isEdgeActivated: true,
                    shouldRestartExistingThreads: false,
                    text: formatMessage({
                        id: 'visionClassifier.whenVisionLabel',
                        default: 'nÃ¥r data er [LABEL]',
                        description: 'Hat-blok der starter nÃ¥r klassifikationen skifter til den valgte klasse'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            menu: 'VISION_LABELS',
                            defaultValue: ''
                        }
                    }
                },
                {
                    opcode: 'isVisionLabel',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'visionClassifier.isVisionLabel',
                        default: 'er data [LABEL]?',
                        description: 'Boolsk blok der fortÃ¦ller om den aktuelle klasse matcher den valgte'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            menu: 'VISION_LABELS',
                            defaultValue: ''
                        }
                    }
                },
                {
                    opcode: 'currentVisionLabel',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'visionClassifier.currentVisionLabel',
                        default: 'aktuel dataklasse',
                        description: 'Reporter-blok for den aktuelle klassifikation'
                    })
                },
                {
                    opcode: 'visionConfidence',
                    blockType: BlockType.REPORTER,
                    labelFn: params => {
                        const label = Cast.toString(params.LABEL || '').trim();
                        return label ? `sikkerhed for ${label}` : 'sikkerhed';
                    },
                    text: formatMessage({
                        id: 'visionClassifier.visionConfidence',
                        default: 'sikkerhed for [LABEL]',
                        description: 'Reporter-blok for den aktuelle sikkerhed pÃ¥ en klasse'
                    }),
                    arguments: {
                        LABEL: {
                            type: ArgumentType.STRING,
                            menu: 'VISION_LABELS',
                            defaultValue: ''
                        }
                    }
                },
                {
                    opcode: 'clearVisionTraining',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'visionClassifier.clearVisionTraining',
                        default: 'ryd datatrÃ¦ning',
                        description: 'Kommandoblok der rydder alle dataeksempler i hukommelsen'
                    })
                },
                {
                    opcode: 'setCameraBackground',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'visionClassifier.setCameraBackground',
                        default: 'sÃ¦t kamerabaggrund [VIDEO_STATE]',
                        description: 'Kommandoblok der tÃ¦nder eller slukker kamerabaggrunden'
                    }),
                    arguments: {
                        VIDEO_STATE: {
                            type: ArgumentType.STRING,
                            menu: 'VIDEO_PREVIEW_STATE',
                            defaultValue: 'on'
                        }
                    }
                },
                {
                    opcode: 'setCameraBackgroundTransparency',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'visionClassifier.setCameraBackgroundTransparency',
                        default: 'sÃ¦t kamerabaggrundens gennemsigtighed til [TRANSPARENCY]',
                        description: 'Kommandoblok der styrer kamerabaggrundens gennemsigtighed'
                    }),
                    arguments: {
                        TRANSPARENCY: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50
                        }
                    }
                },
                {
                    opcode: 'openTrainer',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'visionClassifier.openTrainer',
                        default: '\u00E5bn datatr\u00E6ner',
                        description: 'Tekst til blok der \u00E5bner datatr\u00E6neren'
                    })
                }
            ],
            menus: {
                VISION_LABELS: {
                    acceptReporters: false,
                    items: 'getLabelMenu'
                },
                VIDEO_PREVIEW_STATE: {
                    acceptReporters: false,
                    items: [
                        {
                            text: 'on',
                            value: 'on'
                        },
                        {
                            text: 'off',
                            value: 'off'
                        }
                    ]
                }
            }
        };
    }

    normalizeLabel (label) {
        return Cast.toString(label).trim().toLowerCase();
    }

    getState () {
        return {
            currentLabel: this._state.currentLabel,
            confidences: Object.assign({}, this._state.confidences),
            trainingCounts: Object.assign({}, this._state.trainingCounts),
            labels: this._state.labels.slice(),
            isPredicting: this._state.isPredicting,
            modelReady: this._state.modelReady,
            videoPreviewState: this._state.videoPreviewState,
            videoTransparency: this._state.videoTransparency
        };
    }

    getLabelMenu () {
        if (!this._state.labels.length) {
            return [{
                text: 'ingen klasser endnu',
                value: ''
            }];
        }

        return this._state.labels.map(label => ({
            text: label,
            value: label
        }));
    }

    clearState () {
        this._state = defaultState();
        this.runtime.emit('VISION_CAMERA_PREVIEW_CHANGED', {
            videoPreviewState: this._state.videoPreviewState,
            videoTransparency: this._state.videoTransparency
        });
        this.runtime.requestRedraw();
    }

    setModelReady (ready) {
        this._state.modelReady = Boolean(ready);
        this.runtime.requestRedraw();
    }

    setTrainingData ({labels, trainingCounts}) {
        this._state.labels = Array.isArray(labels) ? labels.slice() : [];
        this._state.trainingCounts = Object.assign({}, trainingCounts);
        this.runtime.requestRedraw();
    }

    setPredicting (isPredicting) {
        this._state.isPredicting = Boolean(isPredicting);
        this.runtime.requestRedraw();
    }

    setCameraPreviewState (state) {
        this.setCameraBackground({
            VIDEO_STATE: state
        });
    }

    setPrediction ({label, confidences}) {
        this._state.currentLabel = Cast.toString(label || '');
        this._state.confidences = Object.assign({}, confidences);
        this.runtime.requestRedraw();
    }

    handleProjectStop () {
        this._state.currentLabel = '';
        this._state.isPredicting = false;
    }

    _ensureVideoDevice () {
        return this.runtime.ioDevices && this.runtime.ioDevices.video;
    }

    _applyCameraPreviewState () {
        const videoDevice = this._ensureVideoDevice();
        if (!videoDevice) return;

        if (this._state.videoPreviewState === 'off') {
            videoDevice.disableVideo();
            return;
        }

        videoDevice.mirror = true;
        videoDevice.enableVideo();
        videoDevice.setPreviewGhost(this._state.videoTransparency);
    }

    openTrainer () {
        this.runtime.emit('VISION_TRAINER_OPEN');
    }

    requestClearTraining () {
        this.runtime.emit('VISION_TRAINER_CLEAR_REQUEST');
        this.clearState();
    }

    whenVisionLabel (args) {
        return this.normalizeLabel(this._state.currentLabel) === this.normalizeLabel(args.LABEL);
    }

    isVisionLabel (args) {
        return this.normalizeLabel(this._state.currentLabel) === this.normalizeLabel(args.LABEL);
    }

    currentVisionLabel () {
        return this._state.currentLabel;
    }

    visionConfidence (args) {
        const normalizedLabel = this.normalizeLabel(args.LABEL);
        const normalizedConfidences = {};

        Object.keys(this._state.confidences).forEach(label => {
            normalizedConfidences[this.normalizeLabel(label)] = this._state.confidences[label];
        });

        return Math.round((normalizedConfidences[normalizedLabel] || 0) * 100);
    }

    clearVisionTraining () {
        this.requestClearTraining();
    }

    setCameraBackground (args) {
        const state = this.normalizeLabel(args.VIDEO_STATE);
        this._state.videoPreviewState = state === 'off' ? 'off' : 'on';
        this._applyCameraPreviewState();
        this.runtime.emit('VISION_CAMERA_PREVIEW_CHANGED', {
            videoPreviewState: this._state.videoPreviewState,
            videoTransparency: this._state.videoTransparency
        });
    }

    setCameraBackgroundTransparency (args) {
        const videoDevice = this._ensureVideoDevice();
        if (!videoDevice) return;

        const transparency = Math.max(0, Math.min(100, Cast.toNumber(args.TRANSPARENCY)));
        this._state.videoTransparency = transparency;
        videoDevice.setPreviewGhost(transparency);
        this.runtime.emit('VISION_CAMERA_PREVIEW_CHANGED', {
            videoPreviewState: this._state.videoPreviewState,
            videoTransparency: this._state.videoTransparency
        });
    }
}

module.exports = Scratch3VisionClassifierBlocks;

